import React, { Component } from 'react';
import cookie from '../../src/cookiecut.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';
import {inject} from 'mobx-react';
import Whynowrite from '../component/whynotwrite'


@withRouter
@inject("store")

export default class BigStory extends Component
{

    one(){
        this.props.store.bigstory = "one";
        this.forceUpdate();
    }
    two(){
        this.props.store.bigstory = "two";
        this.forceUpdate();
    }
    
    render()
    {
        return <div className = "BigStory">
            {this.props.store.bigstory == "nothing" && <h1>欢迎来到大故事指南！</h1>}
              <img src={cookie} className="cookiepicture" alt="cookie" />
              <br/>
              {this.props.store.bigstory == "nothing" && <div className = "storytext">
              会写小故事之后，要怎么才能写出长篇的故事呢<br/><br/>
              当然，可以在写完的小故事后，再继续写小故事<br/>
              同一个主角的一个个小故事，串起一个大故事<br/>
              但这样未免太散乱<br/>
              不如用另一种方法比较好<br/><br/>

              <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.one() } >我想知道方法！</Button><br/>


              </div>}


              {this.props.store.bigstory == "one" &&<div className = "storytext">
                  其实非常简单，就是把小故事拆解成几个部分<br/><br/>
                  比如，把刚刚写的小故事，拆成“起，承，转，合”四个部分<br/><br/>
                  故事开头，是人物介绍，事件变化前的状态介绍或环境介绍<br/><br/>
                  紧接着，人物遇到实现夙愿的机会，事件开始起变化，环境中闯进来了格格不入的人<br/><br/>
                  转折或高潮，是冲突之后，确定人物能实现或不能实现愿望，事件能变化或不能变化，格格不入的人能毁掉或者不能毁掉环境<br/><br/>
                  结局，做个收尾，描述一下人物现在的情况，事件变化后的状态和被毁掉的环境<br/><br/>
                  拆成起承转合（开头，铺垫，高潮，结尾）四份之后，每部分都用一个或多个小故事来讲述。<br/>
                  这样，全部合起来，就是一个大故事啦！<br/><br/>
                  快点试试看吧~~<br/><br/>
                  <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.two() } >我试过了！</Button><br/>
                  </div>}


                  {this.props.store.bigstory == "two" &&<div className = "storytext">
                      好的！现在你已经掌握了故事的写法啦~<br/>
                      不容易不容易（鼓掌撒花花~）<br/><br/>
                      如果对故事拆解有兴趣，可以去公众号“过雨红素”中看结构篇的内容<br/><br/>
                      接下来是故事指南的最后一部分<br/>
                      故事模版<br/><br/>

                      <Button icon="arrow-right" className="Button" minimal={true} onClick={()=>this.props.history.push("/storymodel") } >让我看看</Button><br/>
                      </div>}

           
         
            
             



        </div>;
    }
} 